<!-- <section class='eatec-toast-message' *ngIf='show'>
<div class='message-body'>
  <div class='message'>{{data.message}}</div>
  <button mat-button color="primary" class='toast-button' (click)='dismiss($event)'>{{data.dismissText}}</button>
  <button mat-button color="primary" class='toast-button' (click)='action($event)'>{{data.actionText}}</button>
</div>
</section>
-->

@if (show) {
  <section class='eatec-toast-message'>
    <div class='message-body' (clickOutside)="hide($event)">
      <div class='message'>{{message}}</div>
      @if (undoPresent) {
        <button mat-button color="primary" id="undoButton" class='toast-button' (click)='undo($event)'>{{buttonTextUndo}}</button>
      }
      <button mat-button color="primary" id="dismissButton" class='toast-button' (click)='dismiss($event)'>{{buttonText}}</button>
    </div>
  </section>
}